/**
 * Data-residency region for recipient links assembled in the browser (AU DR).
 *
 * The builder and the documents list build `<whiteLabelBaseUrl>/documents/v1/<referenceId>` client
 * side, so they need the same `region` param the backend puts on the links it generates. The
 * proposals API returns `region` alongside `whiteLabelBaseUrl`, and it is absent on US — so with
 * no region passed these helpers are a no-op and links keep exactly the shape they have today.
 */

export const DR_REGION_QUERY_PARAM = 'region'

/** Normalized region code. '' for US / missing, i.e. the default case. */
export const normalizeDrRegion = (region?: string | null): string => {
  const normalized = region?.trim().toLowerCase()
  return !normalized || normalized === 'us' ? '' : normalized
}

/** Appends `region=<code>` for a non-US region; returns the url untouched otherwise. Idempotent. */
export const appendRegionToUrl = (url: string, region?: string | null): string => {
  const normalized = normalizeDrRegion(region)
  if (!url || !normalized) {
    return url
  }
  if (new RegExp(`[?&]${DR_REGION_QUERY_PARAM}=`).test(url)) {
    return url
  }
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}${DR_REGION_QUERY_PARAM}=${normalized}`
}
